<form class="dados-pedido" novalidate>
  <h2 class="dados-pedido-titulo">Dados do pedido de informação</h2>

  @if (mostrarPendencias() && !store.dadosPedidoValidos()) {
    <p class="dados-pedido-aviso" role="alert">
      <i-lucide name="circle-alert" size="18" aria-hidden="true"></i-lucide>
      Preencha os campos obrigatórios destacados para avançar.
    </p>
  }

  @if (errosServidor().length) {
    <ul class="dados-pedido-aviso dados-pedido-aviso-lista" role="alert">
      @for (erro of errosServidor(); track erro) {
        <li>
          <i-lucide name="circle-alert" size="18" aria-hidden="true"></i-lucide>
          {{ erro }}
        </li>
      }
    </ul>
  }

  @if (store.anonimo()) {
    <p class="dados-pedido-nota">
      <i-lucide name="info" size="16" aria-hidden="true"></i-lucide>
      Como o pedido é anônimo, não há endereço nem e-mail para onde encaminhar a resposta: ela fica
      disponível no portal, consultada pelo número do protocolo.
    </p>
  } @else {
    <div class="dados-pedido-campo">
      <label class="dados-pedido-rotulo" for="dados-pedido-recebimento">
        Forma desejada de recebimento <span class="dados-pedido-obrigatorio" aria-hidden="true">*</span>
      </label>
      <div class="dados-pedido-select-caixa">
        <select
          id="dados-pedido-recebimento"
          class="dados-pedido-input"
          [formField]="store.dadosPedidoForm.formaRecebimento"
        >
          <option value="" disabled>Selecione como deseja receber a resposta</option>
          @for (forma of formasRecebimento; track forma.chave) {
            <option [value]="forma.chave">{{ forma.rotulo }}</option>
          }
        </select>

        <i-lucide class="dados-pedido-select-seta" name="chevron-down" size="18" aria-hidden="true"></i-lucide>
      </div>
      @if (store.dadosPedidoForm.formaRecebimento().touched() && store.dadosPedidoForm.formaRecebimento().invalid()) {
        <p class="dados-pedido-erro">Campo obrigatório.</p>
      }
      @if (store.dadosPedido().formaRecebimento === 'CorrespondenciaFisica') {
        <p class="dados-pedido-ajuda">
          Para a correspondência física, Logradouro, Número e Bairro são obrigatórios na etapa de
          identificação.
        </p>
      }
    </div>
  }

  <div class="dados-pedido-campo">
    <label class="dados-pedido-rotulo" for="dados-pedido-departamento">
      Departamento destino <span class="dados-pedido-obrigatorio" aria-hidden="true">*</span>
    </label>
    <div class="dados-pedido-select-caixa">
      <select
        id="dados-pedido-departamento"
        class="dados-pedido-input"
        [disabled]="store.carregandoDepartamentos()"
        [attr.aria-invalid]="departamentoTocado() && store.dadosPedido().codDepartamento === null"
        (change)="escolherDepartamento($event)"
      >
        <option value="" [selected]="store.dadosPedido().codDepartamento === null" disabled>
          {{ store.carregandoDepartamentos() ? 'Carregando departamentos…' : 'Selecione o departamento que deve responder' }}
        </option>
        @for (departamento of store.departamentos(); track departamento.codDepartamentoDep) {
          <option
            [value]="departamento.codDepartamentoDep"
            [selected]="departamento.codDepartamentoDep === store.dadosPedido().codDepartamento"
          >
            {{ departamento.desNomeDep }}
          </option>
        }
      </select>

      <i-lucide class="dados-pedido-select-seta" name="chevron-down" size="18" aria-hidden="true"></i-lucide>
    </div>
    @if (store.falhaDepartamentos()) {
      <p class="dados-pedido-erro">
        Não foi possível carregar os departamentos.
        <button type="button" class="dados-pedido-link" (click)="store.carregarDepartamentos()">Tentar novamente</button>
      </p>
    } @else if (!store.carregandoDepartamentos() && store.departamentos().length === 0) {
      <p class="dados-pedido-erro">
        @if (store.anonimo()) {
          Nenhum departamento recebe pedidos anônimos no momento. Entre com o seu login para escolher entre todos.
        } @else {
          Nenhum departamento está recebendo pedidos no momento.
        }
      </p>
    } @else if (departamentoTocado() && store.dadosPedido().codDepartamento === null) {
      <p class="dados-pedido-erro">Campo obrigatório.</p>
    }
    @if (store.anonimo() && store.departamentos().length > 0) {
      <p class="dados-pedido-ajuda">
        Na solicitação anônima aparecem só os departamentos que aceitam pedido sem identificação.
      </p>
    }
  </div>

  <div class="dados-pedido-campo">
    <label class="dados-pedido-rotulo" for="dados-pedido-assunto">
      Assunto <span class="dados-pedido-obrigatorio" aria-hidden="true">*</span>
    </label>
    <input
      id="dados-pedido-assunto"
      class="dados-pedido-input"
      type="text"
      placeholder="Resuma em poucas palavras a informação que deseja"
      [formField]="store.dadosPedidoForm.assunto"
    />
    <div class="dados-pedido-medidor">
      <span class="dados-pedido-limite">Máximo de {{ limiteAssunto }} caracteres</span>
      <span class="dados-pedido-contador">{{ caracteresAssunto() }} / {{ limiteAssunto }}</span>
    </div>
    @if (store.dadosPedidoForm.assunto().touched() && store.dadosPedidoForm.assunto().invalid()) {
      <p class="dados-pedido-erro">
        {{ store.dadosPedidoForm.assunto().errors()[0]?.message ?? 'Campo obrigatório.' }}
      </p>
    }
  </div>

  <div class="dados-pedido-campo">
    <label class="dados-pedido-rotulo" for="dados-pedido-descricao">
      Descrição detalhada do pedido <span class="dados-pedido-obrigatorio" aria-hidden="true">*</span>
    </label>
    <textarea
      id="dados-pedido-descricao"
      class="dados-pedido-input dados-pedido-textarea"
      rows="6"
      placeholder="Descreva o pedido de forma clara, objetiva e com o máximo de detalhes possível para facilitar a localização das informações municipais. Evite termos vagos."
      [formField]="store.dadosPedidoForm.descricao"
    ></textarea>

    <div class="dados-pedido-medidor">
      <span class="dados-pedido-limite">Máximo de {{ limitePalavras }} palavras</span>
      <span class="dados-pedido-contador" aria-live="polite">
        {{ store.palavrasDescricao() }} / {{ limitePalavras }}
      </span>
    </div>

    @if (store.dadosPedidoForm.descricao().touched() && store.dadosPedidoForm.descricao().invalid()) {
      <p class="dados-pedido-erro">
        {{ store.dadosPedidoForm.descricao().errors()[0]?.message ?? 'Campo obrigatório.' }}
      </p>
    }
  </div>

  <section class="dados-pedido-preferencias" aria-labelledby="dados-pedido-preferencias-titulo">
    <h3 class="dados-pedido-subtitulo" id="dados-pedido-preferencias-titulo">
      Preferências de notificação
    </h3>

    @if (store.identificado()) {
      <label class="dados-pedido-chave">
        <input
          class="dados-pedido-chave-campo"
          type="checkbox"
          [checked]="store.dadosPedido().receberAvisos"
          (change)="alternarAvisos($event)"
        />
        <span class="dados-pedido-chave-trilho" aria-hidden="true"></span>
        <span class="dados-pedido-chave-texto">
          Desejo receber avisos automáticos e andamentos do pedido diretamente por e-mail.
        </span>
      </label>

      <label class="dados-pedido-chave">
        <input
          class="dados-pedido-chave-campo"
          type="checkbox"
          [checked]="store.dadosPedido().temProtocoloAnterior"
          [attr.aria-expanded]="store.dadosPedido().temProtocoloAnterior"
          (change)="alternarProtocolo($event)"
        />
        <span class="dados-pedido-chave-trilho" aria-hidden="true"></span>
        <span class="dados-pedido-chave-texto">
          Este pedido possui relação direta com um protocolo anterior do e-SIC.
        </span>
      </label>

      @if (store.dadosPedido().temProtocoloAnterior) {
        <div class="dados-pedido-vinculo" id="dados-pedido-vinculo">
          <label class="dados-pedido-rotulo" for="dados-pedido-protocolo">
            Protocolo vinculado <span class="dados-pedido-obrigatorio" aria-hidden="true">*</span>
          </label>
          <input
            id="dados-pedido-protocolo"
            class="dados-pedido-input"
            type="text"
            placeholder="Ex.: SIC-2026-000123-K7Q4X"
            [formField]="store.dadosPedidoForm.protocoloAnterior"
          />

          <p class="dados-pedido-ajuda">
            Informe o número de um pedido anterior seu para que a análise considere o histórico já respondido.
          </p>

          @if (erroProtocoloServidor()) {
            <p class="dados-pedido-erro" role="alert">{{ erroProtocoloServidor() }}</p>
          } @else if (store.dadosPedidoForm.protocoloAnterior().touched() && store.dadosPedidoForm.protocoloAnterior().invalid()) {
            <p class="dados-pedido-erro">
              {{ store.dadosPedidoForm.protocoloAnterior().errors()[0]?.message ?? 'Campo obrigatório.' }}
            </p>
          }
        </div>
      }
    } @else {
      <p class="dados-pedido-nota">
        <i-lucide name="info" size="16" aria-hidden="true"></i-lucide>
        O aviso por e-mail e o vínculo com um protocolo anterior estão disponíveis apenas para pedidos
        identificados com login — a solicitação anônima não vincula um cadastro nem um endereço de e-mail
        ao protocolo.
      </p>
    }
  </section>

  <!-- Invisível para quem usa a tela; o robô que lê o HTML preenche (anti-abuso). -->
  <app-campo-honeypot [(valor)]="store.desafio.honeypot" />
</form>
